<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >资产列表</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    :options="toolbar.statusOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入资产名称或流程ID"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button status="success" @click="addAsset"
                                    >新增</vxe-button
                                >
                                <vxe-button @click="exportDataEvent"
                                    >导出</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        show-overflow
                        class="mytable-scrollbar"
                        :data="tableData"
                        ref="xTable"
                        :height="tableHeight"
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column title="编辑" width="60" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    title="更新资产"
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="修改"
                            width="60"
                            show-overflow
                            :visible="isShowAdminEdit"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    title="管理员编辑资产"
                                    type="text"
                                    icon="fa fa-pencil-square"
                                    @click="editAdminEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="删除" width="60" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            align="center"
                            title="状态"
                            width="100"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-bind:class="{
                                        active: row.AssetStatus === '已生效',
                                        error: row.AssetStatus === '已驳回',
                                    }"
                                    type="text"
                                    @click="showAuditList(row)"
                                >
                                    {{ row.AssetStatus }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="Name"
                            title="资产名称"
                            width="220"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="buSystem"
                            title="业务系统"
                            width="100"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="Description"
                            title="资产描述"
                            width="200"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="ValueType"
                            title="资产类型"
                            width="100"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="ValueName"
                            title="资产值"
                            width="200"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="流程ID"
                            width="140"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="RobotName"
                            title="机器"
                            width="140"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="AssetSet"
                            title="资产集"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="IsUniAuth"
                            title="统一认证登录"
                            width="140"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="CreatorUser"
                            title="创建人"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="创建时间"
                            width="160"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="LastModificationTime"
                            title="修改时间"
                            width="160"
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :page-sizes="[
                            10,
                            20,
                            100,
                            { label: '全部数据', value: 10000 },
                        ]"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <!-- 新增-->
            <vxe-modal
                v-model="formInput.isShow"
                @close="closeWinEvent"
                :title="formInput.title"
                width="800"
                height="440"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="rForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="流程ID"
                            field="ProcessName"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.ProcessName"
                                    placeholder="请输入流程ID"
                                    readonly
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="selectProcess()"
                                    :disabled="formInput.allInputDisable"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="业务系统"
                            field="BuSystem"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.BuSystem"
                                    :options="toolbar.BuSysOptions"
                                    placeholder="请选择业务系统"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                    filterable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="资产类型"
                            field="ValueType"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.ValueType"
                                    placeholder="请选择资产类型"
                                    :disabled="formInput.allInputDisable"
                                    clearable
                                    @change="valueChange"
                                >
                                    <vxe-option
                                        value="5"
                                        label="凭据"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="文本"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="密码到期提醒"
                            field="expireDate"
                            span="12"
                            title-width="120px"
                            :title-prefix="{
                                icon: 'fa fa-info-circle',
                                message:
                                    '如对应业务系统密码需定期修改，维护该日期，系统将会提前3天推送邮件提醒您更新密码',
                            }"
                        >
                            <template #default>
                                <vxe-input
                                    type="date"
                                    v-model="formInput.formData.expireDate"
                                    placeholder="请选择密码到期提醒"
                                    clearable
                                    transfer
                                    :disabled="formInput.allInputDisable"
                                >
                                </vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="系统账号"
                            field="Username"
                            span="12"
                            title-width="100px"
                            :visible-method="isShowUserName"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.Username"
                                    placeholder="请输入系统账号"
                                    :disabled="
                                        !formInput.assetType ||
                                        (formInput.allInputDisable &&
                                            !formInput.showRefreshBtn)
                                    "
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="系统密码"
                            field="Password"
                            span="12"
                            title-width="100px"
                            :visible-method="isShowUserName"
                        >
                            <template #default>
                                <vxe-input
                                    type="password"
                                    v-model="formInput.formData.Password"
                                    placeholder="请输入系统密码"
                                    clearable
                                    :disabled="
                                        !formInput.assetType ||
                                        (formInput.allInputDisable &&
                                            !formInput.showRefreshBtn)
                                    "
                                >
                                </vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="文本"
                            field="Text"
                            span="24"
                            title-width="100px"
                            :visible-method="isShowText"
                        >
                            <template #default>
                                <vxe-input
                                    :disabled="
                                        formInput.assetType ||
                                        (formInput.allInputDisable &&
                                            !formInput.showRefreshBtn)
                                    "
                                    v-model="formInput.formData.Text"
                                    placeholder="请输入文本"
                                    clearable
                                >
                                </vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="资产描述"
                            field="Description"
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    type="text"
                                    v-model="formInput.formData.Description"
                                    placeholder="请输入资产描述"
                                    clearable
                                    :disabled="
                                        formInput.allInputDisable &&
                                        !formInput.showRefreshBtn
                                    "
                                >
                                </vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="系统网址"
                            field="RequestReason"
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.RequestReason"
                                    placeholder="请输入系统网址，客户端请填写”客户端“"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            align="center"
                            span="24"
                            style="position: absolute; bottom: 0"
                        >
                            <template #default>
                                <vxe-button
                                    :disabled="formInput.saveButDisable"
                                    @click="save"
                                    icon="fa fa-save"
                                    v-if="!formInput.saveButDisable"
                                    status="success"
                                    >保存
                                </vxe-button>
                                <vxe-button
                                    @click="submit"
                                    icon="fa fa-check"
                                    :disabled="formInput.saveButDisable"
                                    v-if="!formInput.saveButDisable"
                                    status="primary"
                                    :loading="submitLoading"
                                    >提交
                                </vxe-button>
                                <vxe-button
                                    @click="refresh"
                                    icon="fa fa-refresh"
                                    v-if="formInput.showRefreshBtn"
                                    status="primary"
                                    :loading="submitLoading"
                                    >更新
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <!-- 管理员编辑 -->
            <vxe-modal
                v-model="adminEditForm.isShow"
                title="管理员编辑资产"
                width="520"
                height="260"
                show-zoom
                resize
            >
                <template #default>
                    <vxe-form
                        ref="adminEditFormRef"
                        :data="adminEditForm.formData"
                        :rules="adminEditForm.formRules"
                        title-align="right"
                        title-width="100px"
                    >
                        <vxe-form-item
                            title="流程ID"
                            field="ProcessName"
                            span="24"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="adminEditForm.formData.ProcessName"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="创建人"
                            field="CreatorUser"
                            span="20"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="adminEditForm.formData.CreatorUser"
                                    placeholder="请选择创建人"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="4">
                            <template #default>
                                <vxe-button @click="selectAdminEditUser"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item align="center" span="24">
                            <template #default>
                                <vxe-button
                                    status="success"
                                    icon="fa fa-save"
                                    @click="saveAdminEdit"
                                    >保存</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <vxe-modal
                title="选择用户"
                v-model="adminEditUser.isShow"
                width="640"
            >
                <template #default>
                    <div>
                        <vxe-form>
                            <vxe-form-item title="关键字" :item-render="{}">
                                <template #default>
                                    <vxe-input
                                        v-model="adminEditUser.pager.searchKey"
                                        placeholder="请输入姓名或邮箱"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findAdminEditUsers"
                                        @keyup.enter="findAdminEditUsers"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <vxe-table
                        class="mytable-scrollbar"
                        :data="adminEditUser.tableData"
                        ref="adminEditUserTable"
                        height="300"
                        @cell-dblclick="chooseAdminEditUser"
                        highlight-hover-row
                        highlight-current-row
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="姓名"
                            width="120"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="JobZb"
                            title="总部"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="JobName"
                            title="部门"
                            width="120"
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="UserMail"
                            title="邮箱"
                            width="200"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column field="uid" :visible="false"></vxe-column>
                    </vxe-table>
                    <vxe-pager
                        background
                        v-model:current-page="adminEditUser.pager.currentPage"
                        v-model:page-size="adminEditUser.pager.pageSize"
                        :total="adminEditUser.pager.totalResult"
                        @page-change="findAdminEditUsers"
                        size="small"
                    ></vxe-pager>
                    <div style="width: 100%; text-align: right">
                        <vxe-button
                            status="primary"
                            @click="chooseAdminEditUser"
                            >选择</vxe-button
                        >
                    </div>
                </template>
            </vxe-modal>
            <!-- 选择流程-->
            <vxe-modal
                title="选择流程"
                v-model="processToolbar.isShow"
                width="700"
            >
                <template #default>
                    <div>
                        <vxe-form>
                            <vxe-form-item
                                title="关键字"
                                field="searchKey"
                                :item-render="{}"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="processToolbar.searchKey"
                                        placeholder="请输入流程ID或流程名称"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button @click="findProcessData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="processToolbar.dtData"
                            ref="xTableProcess"
                            height="300"
                            @cell-dblclick="confirmSelectProcess"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="ProcessName"
                                title="流程ID"
                                width="140"
                                resizable
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="ProcessNo"
                                title="流程名称"
                                width="250"
                                show-overflow
                                resizable
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="NAME"
                                title="业务人员"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="邮箱"
                                width="180"
                                resizable
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="ProcessType"
                                :visible="false"
                                title="类型"
                                width="100"
                                sortable
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="
                                processToolbar.pager.currentPage
                            "
                            v-model:page-size="processToolbar.pager.pageSize"
                            :total="processToolbar.pager.totalResult"
                            @page-change="findProcessData"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                    <div style="width: 100%; float: right; text-align: right">
                        <vxe-button
                            status="primary"
                            @click="confirmSelectProcess"
                            >选择</vxe-button
                        >
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";
import { VXETable } from "vxe-table";
import MyAuditLine from "../myPlug/MyAuditLine";

export default {
    name: "AssetList",
    components: { MyAuditLine },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });

        const toolbar = reactive({
            loading: false,
            macOptions: [],
            statusOptions: [],
            BuSysOptions: [],
            formData: {
                selectMac: "",
                searchKey: "",
                status: "",
            },
        });
        const formInput = reactive({
            title: "新增资产",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            showRefreshBtn: false,
            assetType: true,
            formData: {
                Id: "",
                OCAssetId: "0",
                Name: "",
                ProcessName: "",
                BuSystem: "",
                TenantId: "",
                CanBeDeleted: "1",
                ValueScope: "",
                ValueType: "5",
                IsDeleted: "0",
                OrganizationUnitId: "3",
                Description: "",
                AssetSet: "1",
                AssetStatus: "1",
                IsEnable: "1",
                RejectReason: "",
                RequestReason: "",
                expireDate: "",
                Username: "",
                Password: "",
                Creator: "",
                Text: "",
                ProcessType: "",
                IsUniAuth: "",
            },
            formRules: {
                ProcessName: [{ required: true, message: "流程ID不能为空" }],
                BuSystem: [{ required: true, message: "业务系统不能为空" }],
                Username: [{ required: true, message: "系统账号不能为空" }],
                Password: [{ required: true, message: "系统密码不能为空" }],
                ValueType: [{ required: true, message: "资产类型不能为空" }],
                expireDate: [
                    { required: false, message: "密码到期提醒不能为空" },
                ],
                Description: [{ required: true, message: "资产描述不能为空" }],
                RequestReason: [
                    { required: true, message: "系统网址不能为空" },
                ],
                Text: [{ required: false, message: "文本不能为空" }],
                IsUniAuth: [
                    { required: false, message: "统一认证登录不能为空" },
                ],
            },
        });

        const processToolbar = reactive({
            loading: false,
            isShow: false,
            searchKey: "",
            dtData: [],
            pager: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
        });

        const adminEditForm = reactive({
            isShow: false,
            formData: {},
            formRules: {
                Creator: [{ required: true, message: "创建人不能为空" }],
            },
        });

        const adminEditUser = reactive({
            isShow: false,
            tableData: [],
            pager: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
                searchKey: "",
            },
        });

        const cellStyle = ({ row, column }) => {
            if (column.field === "AssetStatus") {
                if (row.AssetStatus === "已生效") {
                    return {
                        color: "#00FF00",
                        fontWeight: "bold",
                    };
                } else if (row.AssetStatus === "已驳回") {
                    return {
                        color: "#FF0000",
                        fontWeight: "bold",
                    };
                }
            }
        };
        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            formInput,
            processToolbar,
            adminEditForm,
            adminEditUser,
            editType: "1", //1 新增 2 修改
            submitLoading: false,
            dtAudit: [],
            isShowAuditList: false,
            cellStyle,
            tableHeight: 0,
            isShowAdminEdit: false,
        };
    },
    methods: {
        closeWinEvent() {
            this.findData();
        },
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        valueChange() {
            if (this.formInput.formData.ValueType === "5") {
                this.formInput.assetType = true;
                this.formInput.formRules.Username[0].required = true;
                this.formInput.formRules.Password[0].required = true;
                this.formInput.formRules.Text[0].required = false;
                this.formInput.formData.Text = "";
            } else if (this.formInput.formData.ValueType === "2") {
                this.formInput.assetType = false;
                this.formInput.formRules.Username[0].required = false;
                this.formInput.formRules.Password[0].required = false;
                this.formInput.formData.Username = "";
                this.formInput.formData.Password = "";
                this.formInput.formRules.Text[0].required = true;
            }
        },
        isShowUserName() {
            return this.formInput.assetType;
        },
        isShowText() {
            return !this.formInput.assetType;
        },
        exportDataEvent() {
            const $table = this.$refs.xTable;
            $table.exportData({ type: "csv" });
        },
        async addAsset() {
            this.formInput.formData = {
                Id: this.$utils.guid(),
                OCAssetId: "0",
                Name: "",
                ProcessName: "",
                BuSystem: "",
                TenantId: "",
                CanBeDeleted: "1",
                ValueScope: "",
                ValueType: "5",
                IsDeleted: "0",
                OrganizationUnitId: "3",
                Description: "",
                AssetSet: "1",
                AssetStatus: "1",
                IsEnable: "1",
                RejectReason: "",
                RequestReason: "",
                expireDate: "",
                Username: "",
                Password: "",
                Creator: "",
                Text: "",
                ProcessType: "",
                IsUniAuth: "",
            };
            this.editType = "1"; //新增
            this.formInput.title = "新增资产";
            this.formInput.assetType = true; //凭证
            this.formInput.formRules.Username[0].required = true;
            this.formInput.formRules.Password[0].required = true;
            this.formInput.formRules.Text[0].required = false;
            this.formInput.allInputDisable = false;
            this.formInput.saveButDisable = false;
            this.formInput.showRefreshBtn = false;
            this.formInput.isShow = true;
            const $rForm = this.$refs.rForm;
            const re = await $rForm.clearValidate();
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.status,
                ],
            };
            this.$api.assetManageAPI
                .getAssetList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        confirmSelectProcess() {
            const $table = this.$refs.xTableProcess;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            this.formInput.formData.ProcessName = record.ProcessName;
            this.formInput.formData.ProcessType = record.ProcessType;
            this.processToolbar.isShow = false;
        },
        handlePageChange() {
            this.findData();
        },
        //提交
        async submit() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitLoading = false;
                return;
            }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                this.formInput.formData.Creator = this.$store.state.userID;
                const data = this.formInput.formData;
                this.submitLoading = true;
                this.$api.assetManageAPI
                    .submitAsset(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitLoading = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0"); //写审核日志
                        this.formInput.isShow = false;
                        this.submitLoading = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitLoading = false;
                        console.log(error);
                    });
            }
        },
        addAuditRecord(status) {
            //写审核日志
            const params = {
                auditBuId: this.formInput.formData.Id,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: "",
                auditNode: "审核发起",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //删除
        async removeEvent(row) {
            // if (row.AssetStatus === '审核中' || row.AssetStatus === '已生效') {
            //   await VXETable.modal.message({content: '审核中或已生效不能删除，请先驳回', status: 'error'});
            //   return;
            // }

            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable;
            if (type === "confirm") {
                this.$api.assetManageAPI
                    .delAsset(
                        Qs.stringify({
                            assetId: row.Id,
                            userId: this.$store.state.userID,
                        })
                    )
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });

                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //编辑数据
        editEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 0,
                pageSize: 0,
                searchKey: [row.Id],
            };
            this.$api.assetManageAPI
                .getOneAsset(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData = res.data.Data;
                    if (
                        this.formInput.formData.AssetStatus == "1" ||
                        this.formInput.formData.AssetStatus == "3"
                    ) {
                        this.formInput.title = "编辑资产";
                        this.formInput.saveButDisable = false;
                        this.formInput.allInputDisable = false;
                    } else {
                        this.formInput.title = "查看资产";
                        this.formInput.saveButDisable = true;
                        this.formInput.allInputDisable = true;
                    }
                    this.formInput.showRefreshBtn =
                        this.formInput.formData.AssetStatus == "4";

                    if (this.formInput.formData.ValueType === 5) {
                        this.formInput.formData.ValueType = "5";
                    } else {
                        this.formInput.formData.ValueType = "2";
                    }
                    this.valueChange();

                    this.editType = "2"; //更新

                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //管理员编辑数据
        editAdminEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 0,
                pageSize: 0,
                searchKey: [row.Id],
            };
            this.$api.assetManageAPI
                .getOneAssetView(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.adminEditForm.formData = res.data.Data;
                    this.adminEditForm.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        selectAdminEditUser() {
            this.adminEditUser.pager.currentPage = 1;
            this.adminEditUser.pager.searchKey = "";
            this.findAdminEditUsers();
            this.adminEditUser.isShow = true;
        },
        findAdminEditUsers() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.adminEditUser.pager.currentPage,
                pageSize: this.adminEditUser.pager.pageSize,
                searchKey: [this.adminEditUser.pager.searchKey, ""],
            };
            this.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.adminEditUser.tableData = res.data.Data.dataTable;
                    this.adminEditUser.pager.currentPage =
                        res.data.Data.currentPage;
                    this.adminEditUser.pager.pageSize = res.data.Data.pageSize;
                    this.adminEditUser.pager.totalResult =
                        res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        chooseAdminEditUser() {
            const record = this.$refs.adminEditUserTable.getCurrentRecord();
            if (!record) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            this.adminEditForm.formData.CreatorUserId = record.Id;
            this.adminEditForm.formData.CreatorUser = record.UserName;
            this.adminEditUser.isShow = false;
        },
        async saveAdminEdit() {
            const formErrMap = await this.$refs.adminEditFormRef.validate();
            if (formErrMap) {
                return;
            }
            let data = {'Id': this.adminEditForm.formData.Id,'CreatorUserId': this.adminEditForm.formData.CreatorUserId};
            this.$api.assetManageAPI
                .updateAssetCreator(Qs.stringify(data))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "保存成功",
                        status: "success",
                    });
                    this.adminEditForm.isShow = false;
                    this.findData();
                })
                .catch((error) => {
                    VXETable.modal.message({
                        content: error,
                        status: "error",
                    });
                    console.log(error);
                });
        },
        bindPC() {
            this.$api.systemManageAPI
                .getMachineList()
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.PcName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindStatus() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["3"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.statusOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.statusOptions.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindBuSys() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["5"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.BuSysOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.BuSysOptions.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        selectProcess() {
            this.processToolbar.searchKey = "";
            this.findProcessData();
            this.processToolbar.isShow = true;
        },
        findProcessData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.processToolbar.pager.currentPage,
                pageSize: this.processToolbar.pager.pageSize,
                searchKey: [
                    this.processToolbar.searchKey,
                    this.$store.state.email,
                ],
            };
            this.$api.publishManageAPI
                .getProcessListToAsset(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.processToolbar.dtData = res.data.Data.dataTable;
                    this.processToolbar.pager.currentPage =
                        res.data.Data.currentPage;
                    this.processToolbar.pager.pageSize = res.data.Data.pageSize;
                    this.processToolbar.pager.totalResult =
                        res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //保存资产
        async save() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            this.formInput.formData.Creator = this.$store.state.userID;
            const data = this.formInput.formData;

            //新增
            if (this.editType === "1") {
                this.$api.assetManageAPI
                    .addAsset(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.alert({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        this.editType = "2"; //新增后是修改

                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        VXETable.modal.alert({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            } else if (this.editType === "2") {
                //更新
                this.$api.assetManageAPI
                    .updateAsset(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.alert({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }

                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            }
        },
        //保存资产
        async refresh() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            this.formInput.formData.Creator = this.$store.state.userID;
            const data = this.formInput.formData;

            //更新资产
            this.$api.assetManageAPI
                .refreshAsset(Qs.stringify(data))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.alert({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "更新成功",
                        status: "success",
                    });
                    this.formInput.isShow = false;
                    this.findData();
                })
                .catch((error) => {
                    VXETable.modal.alert({ content: error, status: "error" });
                    console.log(error);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.selectMac = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
    },
    mounted() {
        this.bindBuSys();
        this.bindStatus();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    created() {
        this.isShowAdminEdit = this.$store.state.isAdmin === "1";
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style scoped>
.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
